import * as apiBff from './bff'

export async function getUniverses<T>(season: string): Promise<T> {
  return apiBff.callBFF<T>('GET', `season/${season}/universes`)
}
